import { useState } from "react";
import { useSnackbar } from "notistack";
import { apiConstants, get } from "../common/constants";
import { downloadExcelFile, downloadFile } from "../common/util";
import { LoadingButton } from "@mui/lab";
import { GetApp } from "@mui/icons-material";

export default function DownloadSampleFile({
  fileName,
  excel,
  label,
  variant = "outlined",
  size = "small",
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isDownloading, setIsDownloading] = useState(false);

  const onButtonClick = (fileName) => {
    setIsDownloading(true);
    const responseObj = excel ? { responseType: "blob" } : {};
    get(apiConstants.DOWNLOAD_SAMPLE_FILE, { fileName }, responseObj)
      .then(({ data }) => {
        if (data) {
          if (excel) {
            downloadExcelFile(data, fileName);
          } else {
            downloadFile(data, fileName);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar("Unable to download sample file", { variant: "error" });
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <LoadingButton
      onClick={() => onButtonClick(fileName)}
      loading={isDownloading}
      variant={variant}
      color="primary"
      size={size}
      startIcon={<GetApp />}>
      {label ? label : "Download Sample File"}
    </LoadingButton>
  );
}
